import { render, staticRenderFns } from "./importRecord.vue?vue&type=template&id=1f8b829f&scoped=true&"
import script from "./importRecord.vue?vue&type=script&lang=js&"
export * from "./importRecord.vue?vue&type=script&lang=js&"
import style0 from "./importRecord.vue?vue&type=style&index=0&id=1f8b829f&prod&lang=css&"
import style1 from "./importRecord.vue?vue&type=style&index=1&id=1f8b829f&prod&scoped=true&lang=css&"
import style2 from "./importRecord.vue?vue&type=style&index=2&id=1f8b829f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b829f",
  null
  
)

export default component.exports